import { render, staticRenderFns } from "./StaffTop.vue?vue&type=template&id=7f8ead0b&scoped=true"
import script from "./StaffTop.vue?vue&type=script&lang=js"
export * from "./StaffTop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f8ead0b",
  null
  
)

export default component.exports